import { logError } from '@/feature-flags/utils/logger';

export function parseJsonAttachment<T>(
  attachment: string | null | undefined,
  fallback: T,
): T {
  if (!attachment) {
    return fallback;
  }

  try {
    const parsed = JSON.parse(attachment);

    if (typeof parsed !== 'object' || parsed === null) {
      logError('Attachment is not a valid JSON object', new Error('Invalid attachment type'), {
        attachment,
      });
      return fallback;
    }

    return parsed as T;
  } catch (error) {
    logError('Failed to parse attachment JSON', error, { attachment });
    return fallback;
  }
}

export function parseAttachmentFlag(
  attachment: string | null | undefined,
  key: string,
): boolean {
  const parsed = parseJsonAttachment<Record<string, unknown>>(attachment, {});

  return parsed[key] === true;
}

export function parseAttachmentStringList(
  attachment: string | null | undefined,
): string[] {
  const parsed = parseJsonAttachment<unknown>(attachment, []);

  return Array.isArray(parsed)
    ? parsed.filter((item): item is string => typeof item === 'string')
    : [];
}
